module.exports = __webpack_public_path__ + "assets/digitalkey.547bb144.svg";